<template>
 <div class="ph-inpage-widget ph-inpage-widget-bottom-right ph-inpage-widget--retro-large3">
       <div class="ph-inpage-widget__content ph-inpage-widget-max-310">
                <div class="ph-inpage-widget__row ph-inpage-widget__row_center">
                    <div class="ph-inpage-widget__thumb  ph-inpage-widget__thumb-rounded-4 ph-inpage-widget__thumb-big">
                        <img :src="require('@/assets/panel/images/inpage/empty.svg')" v-show="!imgIcon" alt="" />
                         <img :src="imgIcon" v-show="imgIcon" />  
                    </div>
                    <div class="ph-inpage-widget__txt">
                        <div class="ph-inpage-widget__title ph-inpage-widget__txt-overflow-1">{{adTitle}}</div>
                        <div class="ph-inpage-widget__desc ph-inpage-widget__txt-overflow-2">{{adText}}</div>
                    </div>
                </div>
                <div class="ph-inpage-widget__btns-row">
                    <div class="ph-inpage-widget__btns-row-item">
                        <a class="ph-inpage-widget__btn ph-inpage-widget__btn-ok">Continue</a>
                    </div>
                    <div class="ph-inpage-widget__btns-row-item">
                        <a class="ph-inpage-widget__btn ph-inpage-widget__btn-cancel">Cancel</a>
                    </div>
                </div>
                <div class="ph-inpage-widget__close ph-inpage-widget__close-border">✕</div>
            </div>
        </div>
</template>

<script>
export default {
  props: ['adTitle','adText','imgIcon']
}
</script>